import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Typography } from 'antd'
import { Icon } from '@iconify/react'

import { REPORTING_REPORTS } from './reporting.constants'
import styles from './ReportingHubPage.module.css'

const { Title } = Typography

const ReportingHubPage = () => {
    const navigate = useNavigate()

    return (
        <div className={styles.page}>
            <header className={styles.header}>
                <Title level={3} className={styles.title}>
                    Reporting
                </Title>
                <p className={styles.subtitle}>
                    Choose a report to view team workload, capacity, and project
                    insights.
                </p>
            </header>

            <div className={styles.content}>
                <div className={styles.grid}>
                    {REPORTING_REPORTS.map((report) => (
                        <button
                            key={report.key}
                            type="button"
                            className={styles.reportCard}
                            disabled={!report.available}
                            onClick={() => navigate(report.route)}
                        >
                            <div className={styles.reportCardTop}>
                                <div className={styles.reportIconWrap}>
                                    <Icon
                                        icon={report.icon}
                                        width={22}
                                        height={22}
                                    />
                                </div>
                                {!report.available ? (
                                    <span className={styles.comingSoonBadge}>
                                        Coming soon
                                    </span>
                                ) : null}
                            </div>
                            <h3 className={styles.reportTitle}>
                                {report.title}
                            </h3>
                            <p className={styles.reportDescription}>
                                {report.description}
                            </p>
                            <div className={styles.reportCardFooter}>
                                <span>
                                    {report.available
                                        ? 'Open report'
                                        : 'Not available yet'}
                                </span>
                                {report.available ? (
                                    <Icon
                                        icon="mdi:arrow-right"
                                        width={16}
                                        height={16}
                                    />
                                ) : null}
                            </div>
                        </button>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default ReportingHubPage
